export default __webpack_public_path__ + "static/media/58t.6caf609d.jpg";